export default __webpack_public_path__ + "static/media/ball_3.5f4038ba.webp";